module.exports = __webpack_public_path__ + "img/hello-template.c20ec7ac.png";